import { BrowserRouter, Route, Routes } from "react-router-dom";
import ReactDOM from "react-dom/client";
import { RemoveTrailingSlash } from "@mirage/components/removeTrailingSlash/RemoveTrailingSlash";
import { DndProvider } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";
import { RecoilRoot } from "recoil";
import { StableNavigateContextProvider } from "@mirage/hooks/useStableNavigate";
import "../../index.css";
import { PrePublicPortalWLRoutingService } from "./services/PrePublicPortalWLRoutingService";
import { PrePublicPortalWestLindsay } from "./app";

const router = new PrePublicPortalWLRoutingService();
const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);

root.render(
    <BrowserRouter basename={process.env.PUBLIC_URL}>
        <RecoilRoot>
            <DndProvider backend={HTML5Backend}>
                <StableNavigateContextProvider>
                    <RemoveTrailingSlash />
                    <Routes>
                        <Route index element={<PrePublicPortalWestLindsay />} />
                        <Route path={`${router.Root}/*`} element={<PrePublicPortalWestLindsay />} />
                    </Routes>
                </StableNavigateContextProvider>
            </DndProvider>
        </RecoilRoot>
    </BrowserRouter>
);

export default PrePublicPortalWestLindsay;
